// extracted by mini-css-extract-plugin
module.exports = {"form":"ContactForm-module--form--3Ot6f","checkboxRow":"ContactForm-module--checkboxRow--1ADc3","centerMobile":"ContactForm-module--centerMobile--3wQmT"};